import { render, staticRenderFns } from "./ModuleName.vue?vue&type=template&id=f0c7c4ee"
import script from "./ModuleName.vue?vue&type=script&lang=js"
export * from "./ModuleName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports